<template>
    <div class="animated fadeIn">
        <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
        <b-form>
          <b-form-group label="Name"
                        description="News Name"
                        :label-cols="3"
                        :horizontal="true">
              <b-form-input type="text" placeholder="Name" v-model="news.name"></b-form-input>
              <validation-errors :errors="news.errors" field="name"></validation-errors>
          </b-form-group>
          <b-form-group label="Publish Date"
                        description="News Publish Date"
                        :label-cols="3"
                        :horizontal="true"
          >
            <datepicker input-class="form-control" v-model="news.publishedAt"></datepicker>
            <validation-errors :errors="news.errors" field="publishedAt"></validation-errors>
          </b-form-group>
          <b-form-group label="Video Link"
                        description="Video Link must be youtube link"
                        :label-cols="3"
                        :horizontal="true"
          >
            <b-form-input type="text" placeholder="Video Link" v-model="news.videoLink"></b-form-input>
            <validation-errors :errors="news.errors" field="videoLink"></validation-errors>
          </b-form-group>
          <b-form-group label="External Link"
                        description="A Link to the external news source"
                        :label-cols="3"
                        :horizontal="true"
          >
            <b-form-input type="text" placeholder="External Link" v-model="news.externalLink"></b-form-input>
            <validation-errors :errors="news.errors" field="externalLink"></validation-errors>
          </b-form-group>
          <b-form-group label="Is Action?"
                        description="Is action news?"
                        :label-cols="3"
                        :horizontal="true"
          >
            <b-form-checkbox v-model="news.isAction"></b-form-checkbox>
          </b-form-group>
          <b-form-group label="Categories"
                        description="News Categories"
                        :label-cols="3"
                        :horizontal="true"
          >
            <b-form-radio-group>
              <b-form-checkbox-group
                :checked="news.categories.map(item => item.category)"
              >
                <b-form-checkbox
                  v-for="(category, key) in categories"
                  :value="category"
                  :key="key"
                  @change="onCategoryChange(category)"
                >{{category}}</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-radio-group>
            <validation-errors :errors="news.errors" field="categories"></validation-errors>
          </b-form-group>
          <b-form-group label="News Content"
                        description="Content"
                        :label-cols="3"
                        :horizontal="true"
          >
            <editor :content="news.content" @change="onEditorChange"></editor>
            <validation-errors :errors="news.errors" field="content"></validation-errors>
          </b-form-group>
          <div slot="footer">
            <news-add-btn
              v-if="addOption"
              :news="news"
              :disabled="validationPassed"
              @click="onStateChange"
            ></news-add-btn>
            <news-save-btn
              v-if="editOption"
              :news="news"
              :disabled="validationPassed"
              @click="onStateChange"
              @success="onSave"
            ></news-save-btn>
          </div>
        </b-form>
    </div>
</template>
<script>
    import Datepicker from "vuejs-datepicker/src/components/Datepicker";
    import {News} from "../../models/News/News";
    import ValidationErrors from "../base/ValidationErrors";
    import {NewsCategory} from "../../models/News/NewsCategory";
    import NewsAddBtn from "./Buttons/NewsAddBtn";
    import VueLoading from "vue-loading-overlay/src/js/Component";
    import Editor from "../base/Editor";
    import NewsSaveBtn from "./Buttons/NewsSaveBtn";

    export default {
        name: 'news-form',
        components: {
          NewsSaveBtn,
          Editor,
          NewsAddBtn,
          ValidationErrors,
          Datepicker,
          VueLoading,
        },
        props: {
          news: {
            type: Object,
            default: new News(),
          },
          addOption: {
            type: Boolean,
            default: false,
          },
          editOption: {
            type: Boolean,
            default: false,
          },
        },
        data() {
          return {
            categories: NewsCategory.CATEGORIES,
            validationPassed: false,
            isLoading: false,
          }
        },
        watch: {
          'news.errors': {
            handler(errors) {
              let keys = Object.keys(errors)
              if (keys.length >= 1) {
                this.validationPassed = true
                return
              }
              this.validationPassed = false
            }
          }
        },
        methods: {
          onStateChange(state) {
            this.isLoading = state
          },
          onEditorChange(value) {
            this.news.content = value
          },
          onSave(news) {
            this.isLoading = false
            this.news = news
          },
          onCategoryChange(category) {
            let hasCategory = this.news.categories.filter(function (item) {
              return item.category === category;
            });

            if (0 === hasCategory.length) {
              this.news.categories.push({category: category})
              return;
            }

            this.news.categories = this.news.categories.filter(function (item) {
              return item.category !== category
            })
          }
        }
    }
</script>
